/**
 * Client-side validation aligned with AthleteService college contact rules:
 * email: optional; if present must match CONTACT_EMAIL_PATTERN shape.
 * phone: optional US; digits only 10, or 11 with leading 1.
 */

const CONTACT_EMAIL_PATTERN = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export function isValidCollegeContactEmail(email: string): boolean {
    const t = email.trim();
    if (!t) return true;
    return CONTACT_EMAIL_PATTERN.test(t);
}

export function isValidUsCollegeContactPhone(phone: string): boolean {
    const t = phone.trim();
    if (!t) return true;
    let digits = t.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.slice(1);
    }
    return digits.length === 10;
}
